import { Button, Form, Modal, Input, InputNumber } from "antd";
import { useState } from "react";
import { useSelector } from "react-redux";
import { IUser } from "../../models/user";
import { useParams } from "react-router-dom";
import { AjaxService } from "../../ducks/ajax/ajax.service";
import { HubLocationService } from "../../ducks/hub-location/hub.location";
import { IClientType } from "../../components/clients/create.client";

interface MyObject {
  state: string;
  value: boolean;
  partition: string;
}

interface IBindUserSpace {
  ajaxService: AjaxService;
  hubLocationService: HubLocationService;
}

const deps: IBindUserSpace = {
  ajaxService: new AjaxService(),
  hubLocationService: new HubLocationService(),
};

function createObjects(n: number): MyObject[] {
  const objects: MyObject[] = [];

  for (let i = 1; i <= n; i++) {
    objects.push({
      state: "ARM",
      value: false,
      partition: i < 10 ? `0${i}` : `${i}`,
    });
  }

  return objects;
}

interface CollectionCreateFormProps {
  open: boolean;
  onCreate: (values: any) => void;
  onCancel: () => void;
}

const BindController = () => {
  const { id } = useParams();
  const [open, setOpen] = useState(false);

  const user = useSelector(({ UserSlice }: any) => UserSlice.user as IUser);

  const BindHubInSpace: React.FC<CollectionCreateFormProps> = ({
    open,
    onCreate,
    onCancel,
  }) => {
    const [form] = Form.useForm();
    const [confirmLoading, setConfirmLoading] = useState(false);

    return (
      <Modal
        open={open}
        title="Подключение контроллера"
        okText="Добавить"
        cancelText="Отменить"
        onCancel={onCancel}
        confirmLoading={confirmLoading}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              setConfirmLoading(true);
              onCreate(values);

              setTimeout(() => {
                setConfirmLoading(false);
              }, 1000);
            })
            .catch((info) => {
              console.log("Validate Failed:", info);
            });
        }}
      >
        <Form form={form} layout="vertical" name="form_in_modal">
          <Form.Item
            name="ip"
            label="IP адрес"
            rules={[
              {
                required: true,
                message: "IP адрес обязателен!",
              },
            ]}
          >
            <Input placeholder="Например, 192.168.1.10" />
          </Form.Item>

          <Form.Item
            name="partitions"
            label="Кол-во зон"
            rules={[
              {
                required: true,
                message: "Кол-во зон объязателено!",
              },
            ]}
          >
            <InputNumber
              min={1}
              style={{ width: "100%" }}
              placeholder="Введите число зон"
            />
          </Form.Item>
        </Form>
      </Modal>
    );
  };

  const handleBindController = async (value: any) => {
    const zones = createObjects(value.partitions);
    const payload = {
      zones,
      ip: value.ip,
      hubId: value.account,
      userId: user.email,
      spaceId: id,
      type: IClientType.Local,
    };

    const response = await deps.hubLocationService.bindArcControllerInLocation(
      payload
    );

    if (response.hubId) {
      window?.location?.reload();
    }
  };

  return (
    <>
      <Button
        type="primary"
        onClick={() => setOpen(true)}
        style={{ marginBottom: 16 }}
      >
        Привязать хаб
      </Button>

      <BindHubInSpace
        open={open}
        onCreate={handleBindController}
        onCancel={() => setOpen(false)}
      />
    </>
  );
};

export default BindController;
